import React, { useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { API_DATE_TIME_FORMAT } from '@ubeya/shared/constants';
import { Button, Flex, FlexSpace, header3SemiBold, PromptClick } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(Flex)`
  flex: 1;
  padding: 40px 15px 20px;
`;

const ApproveAvailabilityButton = styled(Button)`
  border-width: 0;
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    text-decoration: underline;
  }
`;

const Title = styled.div`
  ${header3SemiBold}
  letter-spacing: 2.25px;
  margin-right: auto;
`;

const AvailabilityStatusButton = styled.button.attrs(() => ({ type: 'button' }))`
  background-color: ${({ theme, approved }) =>
    approved ? `${theme.colors.greenPositive}20;` : `${theme.colors.orangeChanges}20;`};
  border: none;
  padding: 9px;
  border-radius: 4px;
  color: ${({ theme, approved }) => (approved ? theme.colors.greenPositive : theme.colors.orangeChanges)};
`;

const LastUpdate = styled.div`
  margin: 0 10px;
`;

const EmployeeAvailabilityHeader = ({
  employeeName,
  availabilityStatus,
  lastUpdate,
  updateStatusApproved,
  isAvailabilityApproved
}) => {
  const { t } = useContext(ConfigContext);
  const dateFormat = 'MM.D.YYYY';

  if (availabilityStatus === undefined) {
    return (
      <Wrapper>
        <Title> {t('generalAvailability')} </Title>
      </Wrapper>
    );
  }

  if (isAvailabilityApproved) {
    return (
      <Wrapper>
        <Title> {t('generalAvailability')} </Title>
        <AvailabilityStatusButton approved>{t('availabilityApproved')}</AvailabilityStatusButton>
        <FlexSpace>
          {lastUpdate && (
            <LastUpdate>
              {`${t('lastUpdatedOn')} - ${moment(lastUpdate, API_DATE_TIME_FORMAT).format(dateFormat)}`}
            </LastUpdate>
          )}
        </FlexSpace>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Title> {t('generalAvailability')} </Title>
      <AvailabilityStatusButton>{t('pendingForApproval')}</AvailabilityStatusButton>
      <FlexSpace>
        <PromptClick
          body={t('areYouSureApproveAvailability', { name: employeeName })}
          confirmText="approve"
          onClick={updateStatusApproved}>
          <ApproveAvailabilityButton link narrow primary type="button" disabled={false}>
            {t('approveAvailability')}
          </ApproveAvailabilityButton>
        </PromptClick>
      </FlexSpace>
    </Wrapper>
  );
};

export default React.memo(EmployeeAvailabilityHeader);
